export interface PasswordCriteria {
  lengthOk: boolean
  hasUpper: boolean
  hasLower: boolean
  hasNumber: boolean
  hasSpecial: boolean
}

export interface PasswordStrengthResult {
  strength: number
  label: string
  criteria: PasswordCriteria
}

const LABELS = [
  'Слишком слабый',
  'Слабый',
  'Средний',
  'Хороший',
  'Отличный',
] as const

export function checkPasswordStrength(
  password: string
): PasswordStrengthResult {
  const criteria: PasswordCriteria = {
    lengthOk: password.length >= 8,
    hasUpper: /[А-ЯA-Z]/.test(password),
    hasLower: /[а-яa-z]/.test(password),
    hasNumber: /\d/.test(password),
    hasSpecial: /[!@#$%^&*(),.?":{}|<>_-]/.test(password),
  }

  let score = 0
  if (criteria.lengthOk) score += 25
  if (criteria.hasUpper) score += 15
  if (criteria.hasLower) score += 15
  if (criteria.hasNumber) score += 20
  if (criteria.hasSpecial) score += 25

  const strength = Math.min(score, 100)
  const labelIndex = Math.min(Math.floor(strength / 25), 4)

  return {
    strength,
    label: LABELS[labelIndex],
    criteria,
  }
}
